import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import CreateRoom from "./routes/CreateRoom";
import Streamer from "./routes/Streamer";
import Viewer from "./routes/Viewer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={CreateRoom} />
          <Route path="/streamer/:roomID" component={Streamer} />

          <Route path="/viewer/:roomID" component={Viewer} />
          <Route path="/streamer" component={Streamer} />
          <Route path="/viewer" component={Viewer} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;